import { Outlet } from 'react-router-dom'

const InterviewCalendar = () => {
  return (
    <><Outlet/></>
  )
}

export default InterviewCalendar